// Background Video Js Start
jQuery(document).on("click", ".cover", function () {
  jQuery(this).children().css({
    "z-index": 1,
    opacity: 1,
  });
  player.play();
});
// Background Video Js End

jQuery(document).on("click", ".custom-sort", function (e) {
  jQuery(".custom-sort").removeClass("active");
  jQuery(this).addClass("active");
  jQuery(this).find('input[type="radio"]').prop("checked", true);
  var changeVal = jQuery(this).attr("data-value");

  jQuery('[name="sort_by"]').val(changeVal).change();
  jQuery('[name="sort_by_clone"]').val(changeVal).change();

  const formData = new FormData(e.target.closest("form"));
  const form = document.querySelector("#CollectionFiltersSortingCloneForm");
  // form.querySelector('[name="sort_by"]').value = formData.get('sort_by_clone');
  form.dispatchEvent(new Event("input"));
});

//  Custom Product Page Brand Slider

window.addEventListener("load", (event) => {
  jQuery(document).ready(function () {
    if (jQuery(".custom_brands_box").length > 0) {
      jQuery(".custom_brands_box").slick({
        dots: false,
        arrows: false,
        speed: 5000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
        swipeToSlide: true,
        centerMode: true,
        focusOnSelect: true,

        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 540,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  });
});

window.addEventListener("load", (event) => {
  jQuery(document).ready(function () {
    let slider = jQuery(".product_data_list .row");
    if (slider.length > 0) {
      let count = slider[0].dataset?.count || 2;
      slider.slick({
        dots: false,
        arrows: false,
        infinite: true,

        speed: 300,
        slidesToShow: count,
        slidesToScroll: 1,

        responsive: [
          {
            breakpoint: 1024,
            settings: {
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  });
});
